import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { PurchaseOrder, Supplier } from '../../../../purchases'
import { Branch } from '../../../../manager'
import { RoutePath, useRoutesHooks } from '../../../../../features/routes'
import { WidgetCard } from '../widget-card/widgetCard'
import { WidgetList, WidgetListRow } from '../widget-list/widgetList'
import { toLocalDateStr } from '../../../utils/dashboardUtils'

type Props = {
    loading: boolean
    error: boolean
    overduePurchases: PurchaseOrder[]
    suppliers: Supplier[]
    branches: Branch[]
}

// Purchase orders with more than 7 days without being received, the oldest first
export const OverduePurchasesWidget = (props: Props) => {
    const { loading, error, overduePurchases, suppliers, branches } = props

    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const rows = useMemo((): WidgetListRow[] => [...overduePurchases]
        .sort((a, b) => a.creationDate.localeCompare(b.creationDate))
        .map(purchase => {
            const [, month, day] = toLocalDateStr(purchase.creationDate).split('-')
            const branchName = branches.find(branch => branch.id === purchase.deliveryBranchId)?.name
            return {
                key: purchase.id,
                label: `#${purchase.code} ${suppliers.find(supplier => supplier.id === purchase.supplierId)?.name || '-'}`,
                detail: branchName,
                value: `${day}/${month}`,
                valueKind: 'warning',
                onClick: () => navigate(getRoutePath(RoutePath.PURCHASES, purchase.id))
            }
        })
    , [overduePurchases, suppliers, branches])

    return (
        <WidgetCard
            title={`Compras atrasadas (${overduePurchases.length})`}
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            emptyLabel="No hay compras atrasadas"
            linkLabel="Ver compras"
            linkPath={RoutePath.PURCHASES}
        >
            <WidgetList rows={rows} maxRows={6} />
        </WidgetCard>
    )
}
